import { Component, OnInit, AfterViewInit, OnDestroy } from '@angular/core';
import { map, catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { FormGroup, FormBuilder, Validators, FormArray } from '@angular/forms';
import { UserProfileModel } from 'lib/ng2-sapmp/src/models';
import { CartModel, ResponseCartModel, RequestCartModel, RequestLineItemModel, ProductModel } from './../../models/';
import { PageLoaderService } from 'lib/ng2-sapmp/src/ui-components/page-loader';
import { ConfirmModalPopupModel } from 'lib/ng2-sapmp/src/ui-components/confirm-modal';
import { UtilityService, ValidationService, AuthenticationService, AdobeAnalyticsService } from 'lib/ng2-sapmp/src/providers';
import { CartService } from './cart.service';
import { BreadCrumbService } from 'lib/ng2-sapmp/src/ui-components/breadcrumb';
import { HeaderService } from './../header/header.service';
import { HttpResponse } from '@angular/common/http';


declare var logoutCurrentUser: any;
declare var checkCart: any;

@Component({
  selector: 'app-cart',
  providers: [ValidationService, CartService],
  templateUrl: './cart.component.html',
  styleUrls: ['./cart.component.scss']
})
export class CartComponent implements OnInit, AfterViewInit, OnDestroy {

  user: UserProfileModel;
  cart: CartModel;
  cartForm: FormGroup;
  confirmModalPopup: ConfirmModalPopupModel;
  productDetail: ProductModel;
  cartHeader: string;
  deleteItem: boolean;
  deleteItemMessage: string;
  deleteIndex: number;
  flushCart: boolean;
  checkOutErrorMessage: string;
  modalClass: string;
  formErrors = [];
  requestCart: RequestCartModel;
  requestLineItem: RequestLineItemModel;
  responseCart: ResponseCartModel;
  field_role1: string;
  permissionJson: any;
  productIds = [];
  eventEmit: any;
  isFormValid: boolean;
  validationMessages = [];
  /*validationMessage = {
    'quantity': {
      'required': 'No.of licenses is required.',
      'pattern': 'Please enter a valid numeric value from  1 to 99999.'
    }
  };*/

  constructor(private router: Router, private formBuilder: FormBuilder,
    private validationService: ValidationService, private cartService: CartService,
    private authenticationService: AuthenticationService,
    private utilityService: UtilityService,
    private pageloaderService: PageLoaderService, private breadCrumbService: BreadCrumbService,
    private adobeAnalyticsService: AdobeAnalyticsService,
    private headerService: HeaderService
    ) {
    this.user = new UserProfileModel();
    this.cart = new CartModel();
    this.requestCart = new RequestCartModel();
    this.responseCart = new ResponseCartModel();
    this.cart.lineItems = [];
    this.requestCart.lineItems = [];
    this.deleteItem = false;
    this.flushCart = false;
    this.cartHeader = 'Shopping cart';
    this.checkOutErrorMessage = undefined;
    this.pageloaderService.setPageLoaderStatus(false);
    this.isFormValid = true;
  }

  ngOnInit() {
    this.headerService.setCondensedFooterStatus(false);
    this.headerService.condensedHeader('cart');
   // document.title = 'AT&T Business Console - Shopping Cart';
    document.title = this.utilityService.getPageTitleConfig()[this.router.routerState.snapshot.url];
    this.breadCrumbService.setCurrentBreadCrumb(undefined);
    this.user = this.authenticationService.getUser();
    this.authenticationService.setLoginSuccessUrl(this.router.routerState.snapshot.url);
    this.field_role1 = 'cart.license';
    this.cart = JSON.parse(sessionStorage.getItem('cart'));
    this.checkCart(this.cart);
    this.cartService.updateCartQty(this.cart);
    this.buildForm();
    if (this.cart && this.cart != null && this.cart.lineItems) {
      let index = 0;
      this.cart.lineItems.forEach((lineItem) => {
        this.cartForm.value.cartItems[index].quantity = lineItem.quantity;
        this.requestLineItem = this.cartService.createRequestCart(lineItem);
        this.requestCart.lineItems.push(this.requestLineItem);
        this.productIds.push(lineItem.productId);
        index++;
      });
      this.cartService.updateQuantityPrice(this.requestCart).subscribe( (orderResponse: HttpResponse<any>) => {
        this.responseCart = orderResponse.body;
        this.cart = this.cartService.updateCartPrice(this.cart, this.responseCart);
        sessionStorage.setItem('cart', JSON.stringify(this.cart));
        this.pageloaderService.setPageLoaderStatus(true);
        for (const lineItem of this.cart.lineItems) {
          if (lineItem.priceInfo.monthlyRecurringFee.amount === 0) {
            this.pageloaderService.setPageLoaderStatus(true);
            const errorObject = { 'status': '500', 'statusText': 'No price details' };
            this.handleError(errorObject);
            break;
          }
        };
      }, error => {
        this.pageloaderService.setPageLoaderStatus(true);
        this.handleError(error);
      });
    } else {
      this.pageloaderService.setPageLoaderStatus(true);
      this.cartService.tokenRefresh();
    }
  }

  handleError = (error) => {
    if (error) {
      if (error.status === 401) {
        this.checkOutErrorMessage = 'Session expired. Please login again.';
        this.isFormValid = false;
        logoutCurrentUser(true);
      } else if (error.status === 400) {
        if (error.error[0]) {
          this.checkOutErrorMessage = error.error[0].errors[0].errorDescription;
        } else {
          this.checkOutErrorMessage = 'Can not add more than max-qty';
        }
        this.isFormValid = false;
      } else {
        this.checkOutErrorMessage = 'We couldn\'t complete your request. Please try again later.';
        this.isFormValid = false;
      }
      this.utilityService.loadFocusOnTop();
      this.adobeAnalyticsService.CreateSeriveAlertProperties(error.status, error.statusText, 'formResponse',
        error.status === 400 ? 'Failure_BusinessRule' : undefined);
    } else {
      throw error;
    }
  }

  checkout() {
    this.router.navigate(['checkout/billing']);
  }

  showEmptyCartModal(event) {
    this.flushCart = true;
    this.confirmModalPopup = new ConfirmModalPopupModel();
    this.confirmModalPopup.modalMessage = 'Emptying your cart will remove all your items. Do you want to empty your cart now?';
    this.confirmModalPopup.modalHeader = 'Empty cart';
    this.confirmModalPopup.cancelButtonMessage = 'No, don\'t empty cart';
    this.confirmModalPopup.confirmButtonMessage = 'Yes, empty cart';
    this.confirmModalPopup.cancelButtonAccessibilityText = 'No, don\'t empty cart.';
    this.confirmModalPopup.confirmButtonAccessibilityText = 'Yes, empty cart.';
    this.modalClass = 'modal-lg';
    this.eventEmit = event.target;
    document.body.classList.add('modal-open');
  }

  emptyCart(continueFlush) {
    if (continueFlush) {
      this.checkFormValid();
      for (const productId of this.productIds) {
        sessionStorage.removeItem('productConfig-' + productId);
      }
      sessionStorage.removeItem('cart');
      // this.headerService.checkCart();
      this.cart = null;
      this.cartService.updateCartQty(this.cart);
    }
    this.flushCart = false;
    document.body.classList.remove('modal-open');
  }

  showDeleteItemModal(i, e, productName) {
    this.deleteIndex = i;
    this.deleteItem = true;
    this.confirmModalPopup = new ConfirmModalPopupModel();
    this.confirmModalPopup.modalMessage = 'Do you really want to remove ' + productName + ' from your cart?';
    this.confirmModalPopup.modalHeader = 'Remove item from cart?';
    this.confirmModalPopup.cancelButtonMessage = 'Cancel';
    this.confirmModalPopup.confirmButtonMessage = 'Yes';
    this.confirmModalPopup.cancelButtonAccessibilityText = 'Cancel.';
    this.confirmModalPopup.confirmButtonAccessibilityText = 'Yes.';
    this.modalClass = 'modal-lg';
    this.eventEmit = event.target;
    document.body.classList.add('modal-open');
  }

  deleteProduct(continueDelete) {
    const delIndex = this.deleteIndex;
    if (continueDelete) {
      this.pageloaderService.setPageLoaderStatus(false);
      this.checkFormValid();
      const lineItems = this.cart.lineItems.filter((data, index) => (index !== delIndex));

      this.requestCart.lineItems = [];
      for (const lineItem of lineItems) {
        this.requestLineItem = this.cartService.createRequestCart(lineItem);
        this.requestCart.lineItems.push(this.requestLineItem);
      }

      if (this.requestCart.lineItems.length > 0) {
        this.cartService.updateQuantityPrice(this.requestCart).subscribe( orderResponse => {
          this.responseCart = orderResponse.body;

          this.cart.lineItems.splice(delIndex, 1);
          this.formErrors.splice(delIndex, 1); // while deleting item, delete error validation as well.
          const control = <FormArray>this.cartForm.controls['cartItems']; // remove error control.
          control.removeAt(delIndex);

          this.cart = this.cartService.updateCartPrice(this.cart, this.responseCart);
          this.cartService.updateCartQty(this.cart);
          sessionStorage.setItem('cart', JSON.stringify(this.cart));
          this.checkCart(this.cart);
          this.pageloaderService.setPageLoaderStatus(true);
        }, error => {
          this.pageloaderService.setPageLoaderStatus(true);
          this.handleError(error);
        });
      } else {
        this.cart.lineItems.splice(delIndex, 1);
        this.formErrors.splice(delIndex, 1);
        const control = <FormArray>this.cartForm.controls['cartItems'];
        control.removeAt(delIndex);
        sessionStorage.setItem('cart', JSON.stringify(this.cart));
        this.checkCart(this.cart);
        // this.headerService.checkCart();
        this.pageloaderService.setPageLoaderStatus(true);
      }
    }
    this.deleteItem = false;
    document.body.classList.remove('modal-open');
  }

  checkCart(cart: CartModel) {
    if (cart === null || cart.lineItems.length < 1) {
      this.cart = null;
      sessionStorage.removeItem('cart');
    }
  }

  updatePrice(rowIndex, isFormError) {
    if (!isFormError) {
      this.checkFormValid();
      this.pageloaderService.setPageLoaderStatus(false);
      this.requestCart.lineItems[rowIndex].quantity = Number(this.cartForm.value.cartItems[rowIndex].quantity);
      this.cartService.updateQuantityPrice(this.requestCart).subscribe(orderResponse => {
        this.responseCart = orderResponse.body;
        this.cart.lineItems[rowIndex].quantity = this.cartForm.value.cartItems[rowIndex].quantity;
        this.cart = this.cartService.updateCartPricewithIndex(this.cart, this.responseCart, rowIndex);
        sessionStorage.setItem('cart', JSON.stringify(this.cart));
        this.pageloaderService.setPageLoaderStatus(true);
      }, error => {
        this.pageloaderService.setPageLoaderStatus(true);
        this.handleError(error);
      });
    }
  }

  buildForm(): void {
    this.cartForm = this.formBuilder.group({
      cartItems: this.formBuilder.array([])
    });
    this.addFormItems();
    this.validationService.validateArray(
      this.cartForm,
      this.formErrors,
      this.validationMessages,
      'cartItems');
  }

  /**
   * this method is form Validation.
   */
  addFormItems() {
    const formArray = <FormArray>this.cartForm.controls['cartItems'];
    if (this.cart && this.cart != null && this.cart.lineItems.length > 0) {
      this.cart.lineItems.forEach((item) => {
        formArray.push(this.buildControlArray(item));
        this.formErrors.push({
          'quantity': ''
        });
        this.validationMessages.push({
          'quantity': {
            'required': 'No.of licenses is required.',
            'pattern': 'Please enter a valid numeric value from  1 to ' + item.maxQty + '.',
            'limitErr': 'No more licenses are available for this purchase.'
          }
        });
      });
    }
  }

  buildControlArray(item) {
    return this.formBuilder.group({
      quantity: [item.quantity, [Validators.required, Validators.pattern('^[1-9][0-9]{0,}$')]]
    }, { validator: this.cartService.checkQty('quantity', item.maxQty) });
  }

  toggleTooltip(event) {
    const targetElement = event.target;
    const elems = document.querySelectorAll('.tooltipActive');
    let iselementActive = false;
    if (targetElement.classList.contains('tooltipActive')) {
      iselementActive = true;
    }
    [].forEach.call(elems, function (ele) {
      ele.classList.remove('tooltipActive');
    });
    if (iselementActive) {
      targetElement.classList.remove('tooltipActive');
    } else {
      targetElement.classList.add('tooltipActive');
    }
  }

  gotoBrowse() {
    this.router.navigate(['/browse']);
  }

  gotoChangeConfigurator(rowIndex) {
    this.productDetail = new ProductModel();
    this.productDetail = JSON.parse(sessionStorage.getItem('productConfig-' + this.cart.lineItems[rowIndex].productId));
    this.productDetail.quantity = this.cart.lineItems[rowIndex].quantity;
    this.productDetail.skus.forEach((productObj) => {
      productObj.selected = (productObj.id === this.cart.lineItems[rowIndex].skuId) ? 1 : 0;
      productObj.isSelectedProduct = (productObj.id === this.cart.lineItems[rowIndex].skuId) ? true : false;
    });
    sessionStorage.setItem('productConfig-' + this.cart.lineItems[rowIndex].productId, JSON.stringify(this.productDetail));
    this.router.navigate(['/productConfigurator/' + this.cart.lineItems[rowIndex].productId]);
  }

  private checkFormValid() {
    this.checkOutErrorMessage = undefined;
    this.isFormValid = true;
  }

  ngAfterViewInit() {
    this.cartService.createPageLoadProperties(this.cart, this.router.routerState.snapshot.url, this.cartHeader, 'BC Cart Pg', 'Buy');
  }
  ngOnDestroy() {
    this.pageloaderService.setPageLoaderStatus(true);
  }
}
